import VALIDATION_PATTERNS from "@/constants/validation";


export const groupBy = (array, key) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});


export const validateField = (type, value) => {
  let re = VALIDATION_PATTERNS[type];
  return re ? re.test(value) : !!value;
};

/**
 * check if value is valid hour: integer in interval 0-23
 */
export const validateHour = value => {
  let parsedValue = parseInt(value);
  return 0 <= parsedValue && parsedValue <= 23;
};

/**
 * check if value is valid minutes: integer in interval 0-59
 */
export const validateMinutes = value => {
  let parsedValue = parseInt(value);
  return 0 <= parsedValue && parsedValue <= 59;
};

/**
 * Get local date in yyyy-mm-dd format
 *
 * TODO: rename
 */
export const toISODate = value => {
  //return value.toISOString().split('T')[0];
  return toRUDate(value).split('.').reverse().join('-');
}

// TODO: remove?
export const toRUDate = value => {
  return value.toLocaleDateString('ru');
}

/**
 * get word declension
 */
export function getDecOfNoun(value = "", titles = []) {
  return titles[
    value % 10 === 1 && value % 100 !== 11
      ? 0
      : value % 10 >= 2 &&
        value % 10 <= 4 &&
        (value % 100 < 10 || value % 100 >= 20)
      ? 1
      : 2
  ];
}
